export const popularizeModalPC = {
  stepOne: {
    title: "步骤一：下载电脑端",
    description: "复制链接前往电脑端下载安装即可试用"
  },
  stepTwo: {
    title: "步骤二：查看手册",
    description: "复制链接前往电脑端查看即可半天学会"
  },
  stepThree: {
    title: "步骤三：更新进度",
    description: "扫描下方二维码以便实时了解 福昕家装系列产品更新进度"
  },
  button: {
    copyLink: "复制链接",
    follow: "去关注"
  },
  message: {
    copySuccess: '复制到剪贴板成功',
    copyGZHSuccess: '复制成功，请去微信搜索关注'
  },
  name: '福昕家装云服务'
}
